export const environment = {
    production: true,
    mainDomain: 'dev.welldone-sport.it',
    baseUrl: 'https://dev.welldone-sport.it',
    apiUrl: 'https://devapi.welldone-sport.it/api',
    publicApiUrl: 'https://devapi.welldone-sport.it/public-api',
    authApiUrl: 'https://devapi.welldone-sport.it/auth-api',
    publicApiToken: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJuYW1lIjoiSUdTb2x1dGlvbnMiLCJzdXJuYW1lIjoiSUdTb2x1dGlvbnMiLCJpZCI6LTIyMTU3Mzk0OTMsImp0aSI6ImJiZDBjZWUxLWRiNzMtNGZlMC1iM2EwLTI0Y2UzNWJjNTJmNCIsImlhdCI6MTU4NTMwOTUwOSwiZXhwIjo0MDc4MzAyODA4fQ.QdG2G7GizuuNHdChAtjPah4lmasyDlMOvo2fmUFZKGg',
    region: 'eu-central-1',
    accessKeyId: 'AKIAQOM4MPJXA3XZVWMK',
    secretAccessKey: '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',
    s3Bucket: 'welldone',
    appName: 'Well Done',
    nexiUrl: 'https://int-ecommerce.nexi.it/ecomm/ecomm/DispatcherServlet',
    stripePublicKey:"pk_test_51SxpHnRo4QAUV3Iht6hB4GtQkDqJetvOiUAI73NjYNGQEgdIwDyOpUduUdWWQsepH8pqWmCU7VjqLeyCdmxklJ7G00iDFajQAa"
};
